<template>
  <div dir="rtl" class="min-h-screen flex items-center justify-center py-12 px-4">
    <div class="w-full max-w-md">

       
      <form class="space-y-6 rounded-2xl bg-[#2B4039]/40 p-8 shadow-xl ring-1 ring-[#334D44]/60" @submit.prevent="sendPhone">
        <div class="flex justify-center mb-2" >
     <img src="/img/Logo.png" width="100px"  alt="لوگوی شرکت" />
   </div>
      <p class="text-center text-lg text-white mb-9">ورود به   سامانه آنلاین طلا و سکه سالاری</p>
        <div class="mt-10">
          <label for="phone" class="block text-sm font-medium text-white/80 mb-2">شماره موبایل</label>
          <input 
            id="phone"
            name="phone"
            type="tel"
            inputmode="tel"
            v-model="form.phone"
            required
            placeholder="شماره با 09 شروع می‌شود"
            class="w-full rounded-xl bg-[#1e2623] text-white placeholder-white/40 px-3 py-2 ring-1 ring-[#334D44] focus:outline-none focus:ring-2 focus:ring-emerald-500 transition"
          />
        </div>
        <button type="submit" class="w-full rounded-xl py-2.5 text-sm font-semibold bg-[#A3FFD1] text-[#0a1f14] shadow-md hover:shadow-lg hover:translate-y-[-1px] active:translate-y-0 transition">
          دریافت کد
        </button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useRouter } from 'vue-router'

const router = useRouter()
const url = process.env.VUE_APP_API_URL
const form = reactive({ phone: '' })

async function sendPhone() {
  try {
    const res = await axios.post(`${url}/auth/login`, { phone: form.phone })
    if (res.status === 200) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: 'کد ارسال شد',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
      })
      router.push({ path: '/otp', query: { phone: form.phone } })
    }
  } catch (err) {
    const msg = err?.response?.data?.error_msg || 'خطا رخ داده است'
    Swal.fire({ toast: true, position: 'top-end', icon: 'error', title: msg, showConfirmButton: false, timer: 3000, timerProgressBar: true })
  }
}
</script>
